import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const DeliveryLogParent = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const RetentionNote = styled.div `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_lighter};
`;
export const LogLayout = styled.div `
    display: grid;
    grid-template-columns: ${(props) => (props.$withInspector ? "minmax(0, 1fr) 400px" : "minmax(0, 1fr)")};
    border: 1px solid ${colors.black_12};
    border-radius: 6px;
    overflow: hidden;
`;
export const LogListPane = styled.div `
    min-width: 0;
    ${(props) => props.$withInspector &&
    css `
            border-right: 1px solid ${colors.black_12};
        `}
`;
export const LogFilterBar = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background-color: ${colors.black_4};
    border-bottom: 1px solid ${colors.black_12};
`;
export const LogFilterChip = styled.button `
    padding: 4px 10px;
    border-radius: 3px;
    font-size: ${fontSizes.TINY};
    cursor: pointer;
    border: 1px solid ${(props) => (props.$active ? colors.blue_main : colors.black_12)};
    color: ${(props) => (props.$active ? colors.blue_main : colors.black_lighter)};
    background-color: ${(props) => (props.$active ? colors.blue_10 : colors.white_main)};

    &:hover {
        border-color: ${(props) => (props.$active ? colors.blue_main : colors.black_lighter)};
    }
`;
export const LogSearchField = styled(HXTextField).attrs({ size: "small" }) `
    margin-left: auto;
    width: 280px;

    & .MuiInputBase-input {
        font-family: monospace;
        font-size: ${fontSizes.TINY};
    }
`;
export const LogRefreshButton = styled(IconButton).attrs({ size: "small" }) `
    color: ${colors.black_lighter};
`;
const statusColors = (outcome) => {
    switch (outcome) {
        case "FAILED":
            return css `
                background-color: ${colors.tulip_50};
                color: ${colors.black_light};
            `;
        case "RETRIED":
            return css `
                background-color: ${colors.sunset_50};
                color: ${colors.black_light};
            `;
        case "DELIVERED":
        default:
            return css `
                background-color: ${colors.forest_50};
                color: ${colors.black_light};
            `;
    }
};
export const StatusCode = styled.span `
    padding: 2px 6px;
    border-radius: 2px;
    font-family: monospace;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.MEDIUM};
    white-space: nowrap;
    ${(props) => statusColors(props.outcome)}
`;
export const AttemptCell = styled.span `
    font-family: monospace;
    font-size: ${fontSizes.TINY};
    color: ${(props) => (props.$terminal ? colors.tulip_main : colors.black_lighter)};
`;
export const ChevronCell = styled.span `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    color: ${colors.black_30};
`;
export const Inspector = styled.div `
    display: flex;
    flex-direction: column;
    min-width: 0;
    background-color: ${colors.black_4};
`;
export const InspectorHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 14px 18px;
    background-color: ${colors.white_main};
    border-bottom: 1px solid ${colors.black_12};
`;
export const InspectorTitle = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const InspectorEventIdRow = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 2px;
`;
export const InspectorEventId = styled.div `
    font-family: monospace;
    font-size: ${fontSizes.MICRO};
    color: ${colors.black_lighter};
    overflow-wrap: anywhere;
`;
export const FollowButton = styled(Button).attrs({ variant: "text", size: "small" }) `
    flex-shrink: 0;
    min-width: 0;
    padding: 0 4px;
    text-transform: none;
    font-size: ${fontSizes.TINY};
    color: ${colors.blue_main};
`;
export const InspectorClose = styled(IconButton).attrs({ size: "small" }) `
    color: ${colors.black_lighter};
`;
export const InspectorSection = styled.div `
    padding: 14px 18px;
    border-bottom: 1px solid ${colors.black_12};
`;
export const InspectorLabel = styled.div `
    margin-bottom: 8px;
    font-family: monospace;
    font-size: ${fontSizes.MICRO};
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${colors.black_lighter};
`;
export const InspectorPayload = styled.pre `
    margin: 0;
    padding: 12px;
    max-height: 260px;
    overflow: auto;
    background-color: ${colors.white_main};
    border: 1px solid ${colors.black_12};
    border-radius: 3px;
    font-family: monospace;
    font-size: ${fontSizes.TINY};
    line-height: 1.55;
    color: ${colors.black_main};
    white-space: pre-wrap;
    overflow-wrap: anywhere;
`;
export const ResponseMetaRow = styled.div `
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    font-family: monospace;
    font-size: ${fontSizes.TINY};
`;
export const ResponseMetaMuted = styled.span `
    color: ${colors.black_lighter};
`;
export const InspectorActions = styled.div `
    display: flex;
    gap: 8px;
    padding: 14px 18px;
    background-color: ${colors.white_main};
`;
export const LoadingSpinnerContainer = styled(FlexColumnDiv) `
    align-items: center;
    padding: 16px;
`;
